<template>
  <div class="dress">
    <div class="title">
      <div>Nicle Han Makeup Studio</div>
      <div class="title-text">妆容分析表</div>
    </div>
    <div class="time">
      <div>日期：{{ currentDate }}</div>
    </div>
    <div class="choose">
      <div class="choose-content" v-for="(item, index) in makeupQuestionList" :key="index">
        <div class="choose-label">{{ item.title }}：</div>
        <div class="item-list">
          <div v-for="(itemOption, indexOption) in item.options" :key="indexOption" class="custom-radio"
            :class="{ active: selectedValues[index].check == itemOption.value }"
            @click="selectOption(itemOption, index)">
            <div :class="selectedValues[index].check == itemOption.value
              ? 'yanyin-active'
              : ''
              " v-if="item.type == 2">
              <div class="yanyin" :style="{ background: itemOption.label.value }"></div>
            </div>
            <div class="checked" v-else>
              <div class="checked-color" v-if="selectedValues[index].check == itemOption.value">
              </div>
              <div class="check-color" v-else></div>
              {{ itemOption.label }}
            </div>
            <!-- <div class="checked" v-else>
              <img :src="selectedValues[index].check == itemOption.value
                ? checked
                : check
                " />
              {{ itemOption.label }}
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="tip">
      <div>如对酒精或特定化妆品成分过敏请提前说明</div>
    </div>
  </div>
</template>

<script>
import reqApi from "@/api/api.js";
export default {
  name: "DressItem",
  components: {},
  data() {
    return {
      selectedValues: [],
      makeupQuestionList: [],
      check: require("@/assets/check.png"),
      checked: require("@/assets/checked.png"),
      currentDate: this.formatDate(),
    };
  },
  created() {
    console.log("created - 实例创建完成，可以访问data和methods");
  },
  mounted() {
    console.log("mounted - 实例已挂载到DOM，可以操作DOM");

    this.getMakeupQuestion();
  },
  methods: {
    selectOption(item, index) {
      this.selectedValues[index].check = item.value;
    },
    getMakeupQuestion() {
      reqApi.makeupQuestion({}).then((res) => {
        let dataObj = res.data.map((item) => {
          const obj = item.options;
          item.options = Object.keys(obj).map((key) => ({
            label: obj[key],
            value: Number(key),
          }));
          return item;
        });
        this.makeupQuestionList = dataObj;
        this.selectedValues = res.data.map((item) => {
          return { title: item.title, check: 0 };
        });
      });
    },
    formatDate() {
      let t = Date.now();
      let time = new Date(t);
      let str = time.getFullYear();
      str += '-';
      str += time.getMonth() < 9 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1;
      str += '-';
      str += time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
      str += ' ';
      // str += time.getHours();
      // str += ':';
      // str += time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
      return str;
    },
  },
};
</script>

<style scoped>
.dress {}

.dress .title {
  font-family: 'DongFangDaKai', sans-serif;
  font-size: 42px;
  color: #000000;
  text-align: center;
  padding: 30px 0 0;
}

.dress .title .title-text {
  font-size: 34px;
  color: #000000;
  text-align: center;
  margin-top: 15px;
}

.dress .time {
  width: 80%;
  margin: 0 auto;
  font-family: sans-serif;
  height: 50px;
  line-height: 50px;
  display: flex;
  justify-content: flex-end;
}

.dress .tip {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.6);
  text-align: center;
  margin-top: 40px;
}

.item-list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.choose {
  width: 80%;
  margin: 0 auto;
  border: 1px solid #e9e9e9;
}

.choose-content {
  font-size: 1em;
  display: flex;
  align-items: start;
  border-bottom: 1px solid #e9e9e9;
  padding: 8px 10px;

}

.choose-content:last-child {
  border-bottom: none;
}

.choose-label {
  width: 160px;
  margin-top: 10px;
  /* font-size: 1.3rem; */
}

.custom-radio {
  padding: 10px;
  display: flex;
}

.custom-radio .checked {
  display: flex;
  align-items: center;
}

.checked:hover,
.checked:focus,
.checked:active {
  background-color: none !important;
}

.checked {
  /* font-size: 1.3rem; */
}

.checked .checked-color {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  margin-right: 10px;
  background: #3987ff;
  border: 1px solid #3987ff;
}

.checked .check-color {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  margin-right: 10px;
  background: #ffffff;
  border: 1px solid #333;
}


.custom-radio:hover {}

.custom-radio {
  position: relative;
}

.yanyin {
  height: 30px;
  width: 30px;
  border-radius: 50%;
}

.yanyin-active::after {
  content: "";
  width: 22px;
  height: 22px;
  background-image: url("../assets/iconActive.png");
  font-family: Arial, sans-serif;
  color: #ffffff;
  position: absolute;
  top: 18px;
  left: 16px;
  background-size: 85%;
  background-repeat: no-repeat;
}
</style>
